export const GENERIC_MESSAGE_ERROR = 'Ocurrio un error, por favor revise sus datos o intenta mas tarde'
export const UNEXPECTED_OOPS = 'Ocurrio un error, por favor intenta mas tarde'
